<template>
  <b-row style="min-height: 681px">
    <b-col sm="12">
      <b-card>
        <b-row class="mt-sm-2">
          <b-col sm="12">
            <b-row>
              <b-col sm="2">
                                <span class="pr-">
                                    <strong>총 {{ totalRows | numberComma }}건</strong>
                                </span>
              </b-col>
              <b-col sm="6"/>
              <b-col sm="2">
                <b-button v-if="!isDownload"
                          variant="outline-primary"
                          style="float: right"
                          v-on:click="downloadExtNewsList()">
                  외부뉴스 다운로드
                </b-button>
                <b-button v-else
                          variant="outline-primary"
                          style="float: right; cursor: default">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"/>
                  외부뉴스 다운로드
                </b-button>
              </b-col>
              <b-col md="2">
                <b-form-group label-cols-sm="5" label="" class="mb-0">
                  <b-form-select
                    v-model="rowPage"
                    :options="pageOptions"
                    v-on:change="findExtNews"
                  ></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row>
          <!-- 로딩 -->
          <b-col sm="12" v-show="listLoading">
            <b-row style="min-height: 634.33px;">
              <b-col sm="5"></b-col>
              <b-col sm="5" class="pt-5 pb-5">
                <PulseLoader color="#20a8d8"></PulseLoader>
              </b-col>
            </b-row>
          </b-col>

          <!-- 목록 -->
          <b-col sm="12" class="pt-sm-1" v-show="!listLoading">
            <b-row>
              <b-col sm="12">
                <b-table outlined :fields="fields" :items="items">
                  <template slot="use_yn" slot-scope="row">
                    <c-switch type="text" variant="primary"
                              v-model="row.item.use_yn"
                              v-on:change="updateUseYn(row.item)"
                              on="On" off="Off"
                              :pill="true" :checked="true"/>
                  </template>
                  <template slot="title" slot-scope="row">
                    <a href="javascript:void(0)" v-on:click="rowExtNewsDetailOpenModal(row.item)">{{
                        row.item.title
                      }}</a>
                  </template>
                  <template slot="view_cnt" slot-scope="row">
                    {{ row.item.view_cnt | numberComma }}
                  </template>
                </b-table>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row>
          <!-- 페이징 -->
          <b-col sm="12" class="pt-sm-1">
            <b-row class="pb-sm-2">
              <b-col sm="12" class="my-1">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="rowPage"
                  :limit="limitPage"
                  @input="findExtNewsPage"
                  align="center"></b-pagination>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card>
      <ExtReportDetailModal v-bind:formModal="formModal" v-bind:item="item" />
    </b-col>
  </b-row>
</template>
<script>
import Vue from "vue";
import VeeValidate from "vee-validate";

const moment = require("moment");

import cSwitch from '../../../../components/Switch';
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { EventBus } from "../../../event-bus";

import ExtReportDetailModal from "./ExtNewsDetailModal";

Vue.use(VeeValidate, {
  inject: true,
  fieldsBagName: "veeFields",
});

export default {
  name: "extNewsList",
  components: {
    PulseLoader,
    cSwitch,
    ExtReportDetailModal,
  },
  props: {
    queryParams: {},
    fullDate: {
      type: Array,
    },
  },
  created() {
    // 이벤트 버스 선언
    EventBus.$on("callFindExtNews", () => {
      this.findExtNews();
    });

    EventBus.$on("findExtNewsPage", () => {
      this.findExtNewsPage();
    });

    EventBus.$on('callExtNewsDetailCloseModal', () => {
      this.closeExtNewsDetailModal();
    });
  },
  data() {
    return {
      listLoading: false,
      totalRows: 0,
      currentPage: 1,
      limitPage: 10,
      rowPage: 10,
      pageOptions: [10, 30, 50, 100],
      fields: [
        { use_yn: { label: "노출여부" } },
        { type_code_k: { label: "메뉴 대분류" } },
        { type_code_k2: { label: "메뉴 소분류" } },
        { site_name: { label: "사이트" } },
        { title: { label: "제목", tdClass: 'tdClass_tl' } },
        { posting_date: { label: "게시일자" } },
        { view_cnt: { label: "조회수" } },
      ],
      items: [],
      isDownload: false,
      formModal: false,
      item: {},
    }
  },
  mounted() {
    this.findExtNews();
  },
  methods: {
    rowExtNewsDetailOpenModal(item) {
      // console.log(item);
      this.item = item;
      this.formModal = true;
    },
    closeExtNewsDetailModal() {
      this.formModal = false;
    },
    // 외부 리포트 검색
    findExtNews() {
      this.currentPage = 1;

      this.listLoading = true;
      this.queryParams.startDate = this.$parent.getFormatDate(this.fullDate[0]);
      this.queryParams.endDate = this.$parent.getFormatDate(this.fullDate[1]);

      this.queryParams.rowPage = this.rowPage;
      this.queryParams.currentPage = this.currentPage - 1;

      // console.log('findExtReport > ', this.queryParams);

      var param = encodeURI(JSON.stringify(this.queryParams));
      var data = new FormData();
      data.append("objs", param);

      this.getList(data);
    },
    findExtNewsPage() {
      this.listLoading = true;
      this.queryParams.startDate = this.$parent.getFormatDate(this.fullDate[0]);
      this.queryParams.endDate = this.$parent.getFormatDate(this.fullDate[1]);

      this.queryParams.rowPage = this.rowPage;
      this.queryParams.currentPage = this.currentPage - 1;

      var param = encodeURI(JSON.stringify(this.queryParams));
      var data = new FormData();
      data.append("objs", param);

      this.getList(data);
    },
    getList(data) {
      var token = sessionStorage.getItem("myToken");

      this.$http
        .post("/api/select/extNewsList?access_token=" + token, data, null)
        .then((result) => {
          this.listLoading = false;
          const { resultListCount, resultList } = result.data;
          this.totalRows = resultListCount;
          this.items = [];
          this.items = resultList;
          if (this.search_user_id !== "" && this.search_user_id !== undefined) {
            this.$parent.rowSessionSelected();
          }
        });
    },
    downloadExtNewsList() {
      this.isDownload = true;
      var token = sessionStorage.getItem("myToken");
      this.queryParams.startDate = this.$parent.getFormatDate(this.fullDate[0]);
      this.queryParams.endDate = this.$parent.getFormatDate(this.fullDate[1]);

      var param = encodeURI(JSON.stringify(this.queryParams));

      var data = new FormData();
      data.append("objs", param);

      var config = {
        responseType: "blob",
      };

      this.$http.post("/download/extNewsListExcel", data, config).then((result) => {
        const url = window.URL.createObjectURL(new Blob([result.data]));
        const link = document.createElement("a");
        link.href = url;
        var fileName = "외부뉴스리스트_" + moment().format("YYYYMMDD");
        link.setAttribute("download", fileName + ".xlsx"); //or any other extension
        document.body.appendChild(link);
        link.click();
        this.isDownload = false;
      });
    },
    updateUseYn(item) {
      var token = sessionStorage.getItem("myToken");

      var param = encodeURI(JSON.stringify(item));
      var data = new FormData();
      data.append('objs', param);

      this.$http.post('/api/update/updateNewsUseState?access_token='+token, data, null)
        .then((result) => {
          const { data } = result;
          if(data !== 'ok'){
            swal.fire({
              type: 'error',
              title: '저장 중 오류가 발생하였습니다.',
              showConfirmButton: false,
              timer: 1500
            })
          }
        });
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/views/contents/extNews/component/ExtNewsList.vue